/**
 * @generated SignedSource<<0bdf0ff87cfc3c2ac79f3faf4fa742fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewBase_DefaultMultilineField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FieldEditIcon">;
  readonly " $fragmentType": "view_issueViewBase_DefaultMultilineField";
};
export type view_issueViewBase_DefaultMultilineField$key = {
  readonly " $data"?: view_issueViewBase_DefaultMultilineField$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewBase_DefaultMultilineField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "view_issueViewBase_DefaultMultilineField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FieldEditIcon"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "fdf40ac3ac3aefb1561c0adb261467d3";

export default node;
